import React, { useMemo } from 'react';
import DeviceStatusBadge from '../DeviceStatusBadge';
import useStyles from './styles';
import {
  HardwareDeviceStatus,
  HardwareStatusSummary,
} from '../../types/HardwareStatus';
import {
  getPrimaryAlarmHardwareStatuses,
  getDeviceStatusIcon,
  getHardwareStatusIcon,
  getLockStatusIcon,
} from '../../utils/hardwareStatus';

type Props = {
  hardwareStatuses?: HardwareDeviceStatus[];
  deviceStatus?: HardwareStatusSummary;
  lockStatus?: HardwareStatusSummary;
};

const HardwareStatusBadges: React.FC<Props> = ({
  hardwareStatuses = [],
  deviceStatus,
  lockStatus,
}: Props) => {
  const classes = useStyles();
  const primaryStatuses = useMemo(
    () => getPrimaryAlarmHardwareStatuses(hardwareStatuses),
    [hardwareStatuses],
  );

  if (primaryStatuses.length) {
    return (
      <div className={classes.statusList}>
        {primaryStatuses.map(hardware => (
          <DeviceStatusBadge
            key={`${hardware.deviceId}-${hardware.deviceType}`}
            label={`${hardware.deviceName}: ${hardware.label}`}
            variant={hardware.variant}
            icon={getHardwareStatusIcon(hardware)}
          />
        ))}
      </div>
    );
  }

  return (
    <div className={classes.statusList}>
      {deviceStatus && (
        <DeviceStatusBadge
          label={`Panel: ${deviceStatus.label}`}
          variant={deviceStatus.variant}
          icon={getDeviceStatusIcon(deviceStatus)}
        />
      )}
      {lockStatus && lockStatus.status !== 'not_available' && (
        <DeviceStatusBadge
          label={`Door Lock: ${lockStatus.label}`}
          variant={lockStatus.variant}
          icon={getLockStatusIcon(lockStatus)}
        />
      )}
    </div>
  );
};

export default React.memo(HardwareStatusBadges);
